type Args = {
  pathname: string;
  propertiesPage: string;
  listingsPage: string;
  isListingsContext?: boolean;
  isListingsNavEnabled?: boolean;
};

/**
 * Active state for the two portfolio nav items. Detail routes live under /properties, so the
 * pathname can't say whether the user came from Listings — hence isListingsContext.
 */
export const getPortfolioNavState = ({
  pathname,
  propertiesPage,
  listingsPage,
  isListingsContext = false,
  isListingsNavEnabled = false,
}: Args) => {
  const isInPropertiesSubtree = pathname.includes(propertiesPage);

  return {
    // Payments guards on this, not isPropertiesActive: its path is the bare substring "payments",
    // so it false-matches the dashboard's payments tab.
    isInPropertiesSubtree,
    // Only hand the highlight over when the Listings item is rendered, or nothing would be active.
    isPropertiesActive: isInPropertiesSubtree && !(isListingsContext && isListingsNavEnabled),
    isListingsActive: pathname.includes(listingsPage) || (isListingsContext && isListingsNavEnabled),
  };
};
